import { ReviewWorkflowStatus } from '../../types/pms';

export const REVIEW_STATUS_COLORS: Record<ReviewWorkflowStatus, string> = {
  [ReviewWorkflowStatus.DRAFT]: '#94a3b8',
  [ReviewWorkflowStatus.IN_PROGRESS]: '#2563eb',
  [ReviewWorkflowStatus.SUBMITTED]: '#8b5cf6',
  [ReviewWorkflowStatus.COMPLETED]: '#16a34a',
  [ReviewWorkflowStatus.REOPEN_REQUESTED]: '#f59e0b',
};

export const OVERDUE_COLOR = '#dc2626';

export interface ChartDistributionRow<T> {
  key: T;
  count: number;
  percentage: number;
  color: string;
}

export function calculatePercentage(count: number, total: number): number {
  if (total <= 0 || count <= 0) return 0;
  return (count / total) * 100;
}

export function buildStatusDistribution(
  order: ReviewWorkflowStatus[],
  counts: Map<ReviewWorkflowStatus, number>,
  total: number
): ChartDistributionRow<ReviewWorkflowStatus>[] {
  return order.map((status) => {
    const count = counts.get(status) || 0;
    return {
      key: status,
      count,
      percentage: calculatePercentage(count, total),
      color: REVIEW_STATUS_COLORS[status],
    };
  });
}

export function formatChartPercentage(percentage: number): string {
  return `${Number.isInteger(percentage) ? percentage : percentage.toFixed(1)}%`;
}
